const initModule = (module) => {
    const mediaElements = module.querySelectorAll('.m-multi-editorial__media');
    const items = module.querySelectorAll('.m-multi-editorial__item');
    const menuElements = module.querySelectorAll('.m-multi-editorial__menu-element');
    menuElements.forEach((menuElement) => {
        menuElement.addEventListener('click', (event) => {
            event.preventDefault();
            items.forEach((item) => item.classList.toggle('active', menuElement.dataset.id === item.dataset.id));
            mediaElements.forEach((mediaElement) => mediaElement.classList.toggle('active', menuElement.dataset.id === mediaElement.dataset.id));
            menuElements.forEach((currentMenuElement) => currentMenuElement.classList.toggle('active', currentMenuElement === menuElement));
        });
    });
};
export const initMultiEditorial = () => {
    const modules = document.querySelectorAll('.m-multi-editorial');
    modules.forEach((module) => initModule(module));
};
